export interface ControlledListContext<T> {
  items: T[]
  remove: (index: number) => void
  clear: () => void
}

export interface IControlledListProps<T = any> {
  items?: T[]
  children?: (context: ControlledListContext<T>) => JSX.Element
  onChange?: (items: T[], removedItem: T | T[]) => void
}

export const ControlledList = <T extends {}>({
  children,
  items,
  onChange,
}: IControlledListProps<T>) => {
  const handleOnRemove = (index: number) => {
    const newItems = items.slice()

    const removedItem = newItems.splice(index, 1)[0]

    if (onChange) {
      onChange(newItems, removedItem)
    }
  }

  const handleClearAll = () => {
    if (onChange) {
      onChange([], items)
    }
  }

  return children({
    items,
    remove: handleOnRemove,
    clear: handleClearAll,
  })
}

ControlledList.displayName = 'ControlledList'
